import { styled } from '@porsche-code/kado-styled-system/jsx';

export const Indicator = ({
  label,
  active,
  disabled,
  children,
  compact,
  ...props
}: {
  label?: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  compact?: boolean;
}) => {
  return (
    <Container>
      <Dot disabled={disabled} active={active} compact={compact} {...props}>
        {label}
      </Dot>
      {children}
    </Container>
  );
};

const Container = styled('div', {
  base: {
    position: 'relative',
  },
});

const Dot = styled('div', {
  base: {
    position: 'absolute',
    left: '60%',
    top: -6,
    minWidth: 12,
    fontSize: 11,
    lineHeight: 1.4,
    color: 'text.primary',
    backgroundColor: 'background.canvas',
    backdropFilter: 'blur(32px)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.colorContrastMedium',
    borderRadius: 'full',
    zIndex: 1,
    userSelect: 'none',
    pointerEvents: 'none',
    padding: '1px 3px',
    textAlign: 'center',

    '&:empty': {
      top: -4,
      right: -4,
      width: 14,
      height: 14,
      padding: 0,
    },
  },

  variants: {
    disabled: {
      true: {
        visibility: 'hidden',
      },
    },

    active: {
      true: {
        color: 'text.info',
        backgroundColor: 'background.infoFrosted',
        borderColor: 'border.infoMedium',
      },
    },

    compact: {
      true: {
        fontSize: 9,
        padding: 0,
        top: -4,
      },
    },
  },
});
